import { Controller } from '@hotwired/stimulus'
import { jquery } from 'utils/jquery'

export default class extends Controller {
  static targets = ['languageSelect']

  declare languageSelectTarget: HTMLSelectElement;

  connect(): void {
    const $ = jquery();
    if (!$) {
      return;
    }

    $(this.languageSelectTarget).select2();
  }
}
